<div class="modal-header">
  <h4 class="modal-title" id="modal-title">
    {{ "customManufacturerCampaign.export.heading" | cxTranslate }}
  </h4>
  <button
    type="button"
    class="close"
    aria-describedby="modal-title"
    (click)="modal.dismiss('Cross click')"
    >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="container-fluid">
    <div class="form-group">
      <div>
        <span>
          <ng-select
            id="campaignId"
            [searchable]="false"
            [clearable]="false"
            (change)="selectCampaign()"
            [(ngModel)]="selectedCampaigns"
            [maxSelectedItems]="3"
            multiple="true"
            placeholder="{{ 'customManufacturerCampaign.export.selectCampaignOptions' | cxTranslate }}"
            required
            >
            <ng-option [value] ="null" [disabled]="true"  ><div>{{ "customManufacturerCampaign.export.selectCampaignOptions" | cxTranslate }}</div></ng-option>
            @for (campaignProduct of campaignProductsMap | keyvalue; track campaignProduct) {
              <ng-option
                [value]="campaignProduct.key"
                >
                <div>{{ campaignProduct.key }}</div>
              </ng-option>
            }
          </ng-select>
        </span>
      </div>

      @if (selectedCampaigns) {
        <div class="product-selection-info">
          {{ "customManufacturerCampaign.export.productInfo" | cxTranslate }}
        </div>
        @for (
          product of campaignProducts; track
          product; let i = $index; let odd = $odd; let even = $even) {
          <div
            [value]="product"
            class="form-check"
            >
            @if (even) {
              <div class="row">
                <div class="col">
                  <input
                    #productCheckboxes
                    class="form-control"
                    type="checkbox"
                    name="{{ campaignProducts[i] }}"
                    id="{{ campaignProducts[i] }}"
                    value="{{ campaignProducts[i] }}"
                    />
                    <label class="form-check-label" for="product">
                      {{ campaignProducts[i] }}
                    </label>
                  </div>
                  @if (campaignProducts[i + 1]) {
                    <div class="col">
                      <input
                        #productCheckboxes
                        class="form-control col"
                        type="checkbox"
                        name="{{ campaignProducts[i + 1] }}"
                        id="{{ campaignProducts[i + 1] }}"
                        value="{{ campaignProducts[i + 1] }}"
                        />
                        <label class="form-check-label" for="product">
                          {{ campaignProducts[i + 1] }}
                        </label>
                      </div>
                    }
                  </div>
                }
              </div>
            }
          }
        </div>
        <div class="links">
          <div class="check-link">
            <a (click)="uncheckAllColumns()">
              {{ "uigexport.dialog.clearAll" | cxTranslate }}
            </a>
          </div>
          <div class="check-link">
            <a (click)="checkAllColumns()">
              {{ "uigexport.dialog.selectAll" | cxTranslate }}
            </a>
          </div>
        </div>
        @if (emptyResults$ | async) {
          <div class="empty-result">
            {{ "customManufacturerCampaign.export.noResults" | cxTranslate }}
          </div>
        }
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-primary"
        (click)="modal.dismiss('cancel click')"
        >
        {{ "common.cancel" | cxTranslate }}
      </button>
      <button
        type="button"
        class="btn btn-primary"
        (click)="onSubmit()"
        [disabled]="disableSubmitButton"
        >
        {{ "common.submit" | cxTranslate }}
      </button>
    </div>
